import * as React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import SimpleSelectFilter from '../Filter/SimpleSelectFilter';
import LoaderService from '../../../Services/LoaderService';
import useFilter from '../hooks/useFilter';
import TooltipComponent from '../../TooltipComponent';
import { ITripsOverviewColumn } from '../interfaces';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { columnsAtom, rideBookFilterAtom } from '../TripsOverviewState';
import { getDataForFilter } from '../TripsOverviewService';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThCustomerProps {
  id: string;
}

function ThCustomer(props: IThCustomerProps): JSX.Element {
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    rideBookFilterAtom(props.id)
  );
  const { formatMessage: f } = useIntl();
  const { updateFilterItemsState } = useFilter();
  const { trackEvent } = useAnalytics();

  const getFilterData = async () => {
    LoaderService.showLoader(true);
    const dataForFilter = await getDataForFilter('customer');

    if (dataForFilter) {
      updateFilterItemsState([
        { id: props.id, isOpen: true, isActionChipsOpen: false, data: dataForFilter, values: null },
      ]);

      LoaderService.showLoader(false);
    } else {
      LoaderService.showLoader(false);
    }
  };

  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);

    setTableActionsFilters(
      (tableActionFilter) =>
        tableActionFilter && {
          ...tableActionFilter,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        }
    );

    if (id) {
      if (!tableActionsFilters) {
        getFilterData();
      }
    }
  };

  const renderSimpleSelect = (): JSX.Element | null => {
    if (tableActionsFilters && tableActionsFilters.isOpen && tableActionsFilters.data) {
      return (
        <div style={{ position: 'absolute', left: '0', top: '47px' }}>
          <SimpleSelectFilter
            id={props.id}
            filterValues={tableActionsFilters.data}
            search={true}
            title={f({ id: 'enum.waypoints.category.customer' })}
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className={`th-sticky b-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        minWidth: '100px',
        flex: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'enum.waypoints.category.customer',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.customer',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, props.id)}
      >
        <div className="d-flex w-100">
          <div
            id={props.id}
            onClick={handleOnClick}
            className="text-truncate"
            data-cy={`filter-button-text-${props.id}`}
          >
            {f({ id: 'enum.waypoints.category.customer' })}
          </div>

          <a
            id={props.id}
            href="#"
            className="filter cmd-icons cmd-icon-filter"
            onClick={handleOnClick}
            data-cy={`filter-button-${props.id}`}
          >
            {/* test */}
          </a>
          <div />
        </div>
      </TooltipComponent>{' '}
      {renderSimpleSelect()}
    </div>
  );
}

export default ThCustomer;
